import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    onSearchDistribuidorClick,
    onUpdateFieldFilter,
    onSearchCategoriaClick,
    onSearchTipoFormatoClick,
} from "../../../store/fuerzaventas/cargarmiespacio/actions";

import { ActionField, FieldSet } from "@sigeco/tools";
import Grid from "@material-ui/core/Grid";
import makeStyles from "@material-ui/core/styles/makeStyles";
import TextField from "@material-ui/core/TextField";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import FormControl from "@material-ui/core/FormControl";
import { Icon } from "@material-ui/core";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles(() => ({
    content: {
        padding: "0.5rem 0.75rem 0.75rem",
    },
    filterClear: {
        display: "flex",
    },
    actionField: {
        flexDirection: "row",
        position: "relative",
    },
    btnClear: {
        position: "absolute",
        bottom: "1.5",
        right: 20,
        maxWidth: "15px",
        maxHeight: "23px",
        minWidth: "15px",
        minHeight: "23px",
    },
    root: {
        flex: "0 0 auto",
        marginBottom: "0.75rem",
        "@media (min-width: 1401px)": {
            marginBottom: "1rem",
        },
    },
}));

const CargarMiEspacioFilter = () => {
    const classes = useStyles();
    const matches = useMediaQuery("(min-width:701px)");
    const filters = useSelector((state) => state.cargarmiespacio.filters);
    const dispatch = useDispatch();

    //console.log("fecha: ",typeof filters.hasta)

    //Botones de limpiar filtros
    const [, setDistribuidor] = useState("");
    const [btn, setBtn] = useState(true);

    const [, setCategoria] = useState("");
    const [btn1, setBtn1] = useState(true);

    const [, setTipoFormato] = useState("");
    const [btn2, setBtn2] = useState(true);

    const [, setName] = useState("");
    const [btn3, setBtn3] = useState(true);

    useEffect(() => {
        if (filters.dDistribuidor) {
            setDistribuidor(filters.dDistribuidor);
            setBtn(false);
        } else {
            setBtn(true);
        }
    }, [filters.dDistribuidor]);

    useEffect(() => {
        if (filters.dCategoriaArchivo) {
            setCategoria(filters.dCategoriaArchivo);
            setBtn1(false);
        } else {
            setBtn1(true);
        }
    }, [filters.dCategoriaArchivo]);

    useEffect(() => {
        if (filters.dTipo) {
            setTipoFormato(filters.dTipo);
            setBtn2(false);
        } else {
            setBtn2(true);
        }
    }, [filters.dTipo]);

    useEffect(() => {
        if (filters.nombre) {
            setName(filters.nombre);
            setBtn3(false);
        } else {
            setBtn3(true);
        }
    }, [filters.nombre]);

    const handleDist = () => {
        setDistribuidor("");
        setName("");
        filters.distribuidorId = 0;
        filters.dDistribuidor = "";

        filters.categoriaArchivoId = 0;
        filters.dCategoriaArchivo = "";

        filters.tipoId = 0;
        filters.dTipo = "";

        filters.nombre = "";

        setBtn(true);
        setBtn1(true);
        setBtn2(true);
        setBtn3(true);
    };

    const handleCategoriaArchivo = () => {
        setCategoria("");
        filters.dCategoriaArchivo = "";
        filters.categoriaArchivoId = 0;
        setBtn1(true);
    };
    const handleTipoFormato = () => {
        setTipoFormato("");
        filters.dTipo = "";
        filters.tipoId = 0;
        setBtn2(true);
    };
    const handleName = () => {
        setName("");
        filters.nombre = "";
        setBtn3(true);
    };

    function onFieldChange(event) {
        dispatch(onUpdateFieldFilter(event.target.name, event.target.value));
    }

    return (
        <div className={classes.root}>
            <FieldSet iconCls="fas fa-file-alt" title="Filtros" defaultExpanded>
                <Grid className={classes.content} container spacing={2}>
                    <Grid item xs={12} container spacing={2}>
                        <Grid item>
                            <FormControl className={classes.filterClear}>
                                <ActionField
                                    className={classes.actionField}
                                    label="Agente"
                                    placeholder="Enter para buscar un Agente"
                                    value={filters.dDistribuidor}
                                    variant={matches ? "outlined" : "standard"}
                                    onHandleAction={() => dispatch(onSearchDistribuidorClick())}
                                />
                                <Button
                                    className={classes.btnClear}
                                    size="small"
                                    startIcon={<Icon className="fa fa-window-close" />}
                                    disabled={btn}
                                    onClick={handleDist}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item>
                            <FormControl className={classes.filterClear}>
                                <ActionField
                                    className={classes.actionField}
                                    label="Categoria"
                                    placeholder="Enter para selecionar una Categoria"
                                    value={filters.dCategoriaArchivo}
                                    variant={matches ? "outlined" : "standard"}
                                    onHandleAction={() => dispatch(onSearchCategoriaClick())}
                                />
                                <Button
                                    className={classes.btnClear}
                                    size="small"
                                    startIcon={<Icon className="fa fa-window-close" />}
                                    disabled={btn1}
                                    onClick={handleCategoriaArchivo}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item>
                            <FormControl className={classes.filterClear}>
                                <ActionField
                                    className={classes.actionField}
                                    label="Tipo de Formato"
                                    placeholder="Enter para seleccionar el tipo de formato"
                                    value={filters.dTipo}
                                    variant={matches ? "outlined" : "standard"}
                                    onHandleAction={() => dispatch(onSearchTipoFormatoClick())}
                                />
                                <Button
                                    className={classes.btnClear}
                                    size="small"
                                    startIcon={<Icon className="fa fa-window-close" />}
                                    disabled={btn2}
                                    onClick={handleTipoFormato}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid className={classes.content} container spacing={2}>
                    <Grid item xs>
                        <FormControl className={classes.filterClear}>
                            <TextField
                                autoComplete="off"
                                fullWidth
                                label="Nombre del archivo"
                                name="nombre"
                                value={filters.nombre}
                                variant={matches ? "outlined" : "standard"}
                                onChange={onFieldChange}
                            />
                            <Button
                                style={{ right: 0 }}
                                className={classes.btnClear}
                                size="small"
                                startIcon={<Icon className="fa fa-window-close" />}
                                disabled={btn3}
                                onClick={handleName}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
            </FieldSet>
        </div>
    );
};

export default CargarMiEspacioFilter;
